import React from "react";
import { XCircle } from "lucide-react";
export default function OrderFailedModal({ isOpen, onClose, message }) {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-40">
            <div className="rounded-xl w-96 p-6 flex flex-col items-center shadow-2xl text-center bg-white">

                {/* Error Icon */}
                <XCircle size={48} className="mb-4 text-red-500" />

                {/* Title */}
                <h3 className="text-xl font-bold mb-2" style={{ color: 'var(--color-text)' }}>Order Failed</h3>

                {/* Error message */}
                <p className="text-sm mb-6 text-gray-600">
                    {message || "Failed to process order. Please try again."}
                </p>

                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="font-semibold px-6 py-2 rounded-md bg-red-500 text-white hover:bg-red-600 transition-colors focus:outline-none"
                >
                    Close
                </button>
            </div>
        </div>
    );
}
